<component :is="tag">
    <slot></slot>
</component>
